import Emitter from "component-emitter";

/**
 * Singleton event bus
 */
const bus = new Emitter();

export default bus;
